<template>
  <!-- 最大的盒子 -->
  <div class="content">
    <div class="box">
      <!-- 左侧logo -->
      <div class="left"><img src="./images/leftLogo.png" alt="" /></div>
      <!-- 右侧登录 -->
      <div class="right">
        <!-- 登录 -->
        <div class="login_content">
          <div class="logo"><img src="./images/logo.png" alt="" /></div>
          <div class="title1">生涯规划平台</div>
          <div class="title2">Career planning system platform</div>
          <!-- 单选框 -->
          <div class="options">
            <el-radio v-model="radio" label="1">学生</el-radio>
            <el-radio v-model="radio" label="2">教师</el-radio>
          </div>
          <div class="login">
            <!-- 登录框 -->
            <el-form ref="loginForm" :model="loginForm" :rules="loginRules" label-width="80px">
              <el-form-item prop="account">
                <div class="login_title">账号</div>
                <el-input prefix-icon="el-icon-user" v-model="loginForm.account" placeholder="请输入账号"></el-input>
              </el-form-item>
              <el-form-item prop="password">
                <div class="login_title">密码</div>
                <el-input show-password prefix-icon="el-icon-lock" v-model="loginForm.password"
                  placeholder="请输入密码"></el-input>
                <div class="forget"><a href="">忘记密码</a></div>
              </el-form-item>
            </el-form>
            <el-button @click="login">登录</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validAccount } from "@/utils/validate";
// import { reqLogin } from "@/api/user";
export default {
  name: "HLogin",

  data() {
    const validateAccount = (rule, value, callback) => {
      console.log("我们要校验的用户名", value);
      if (!validAccount(value)) {
        callback(new Error("请输入正确的用户名"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error("请输入正确的密码"));
      } else {
        callback();
      }
    };
    return {
      radio: "1",
      loginForm: {
        account: "42092219910516",
        password: "123456",
      },
      loginRules: {
        //  validator自定义校验规则
        account: [
          { required: true, trigger: "blur", validator: validateAccount },
        ],
        password: [
          { required: true, trigger: "blur", validator: validatePassword },
        ],
      },
    };
  },

  mounted() { },

  methods: {
    login() {
      console.log(1);
      // 手动兜底校验
      // this.$refs.loginForm.validate(async (valid) => {
      //   if (valid) {
      //     // await this.$store.dispatch("user/userLogin", this.loginForm);
      //     //登录
      //     const res = await reqLogin(this.loginForm);
      //     if (res.code == 200) {
      //       this.$message.success("登录成功~");
      //       this.$store.commit("user/setOtherUrl", res.data.otherUrl);
      //       this.$store.commit("user/setTokens", res.data.data);
      //       this.$store.commit("user/setTenantId", res.data.tenantId);
      //       this.$store.commit("user/setStudentInfo", res.data.studentInfo);
      this.$router.push("/");
      //     } else {
      //       // window.location.href = this.$store.state.user.otherUrl;
      //       this.$message.error("账号或者密码错误");
      //     }
      //   } else {
      //     return false;
      //   }
      // });
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/global.less";

.content {
  height: 100%;

  .box {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .left {
      height: 100%;

      img {
        height: 100%;
      }
    }

    .right {
      height: 100%;
      background-color: #fff;

      .login_content {
        box-sizing: border-box;
        padding: 77px 50px 0 50px;
        height: 1080px;

        .logo {
          width: 155px;
          height: 62px;
          margin-bottom: 93px;
        }

        .title1 {
          font-size: 38px;
          font-weight: 600;
          margin-bottom: 5px;
        }

        .title2 {
          font-size: 24px;
          color: #999999;
          margin-bottom: 80px;
        }

        .login {
          margin-top: 31px;

          .login_title {
            font-size: 28px;
            color: #666;
            margin-bottom: 10px;
          }

          .forget {
            font-size: 18px;
            margin-top: 15px;
            color: #999999;
          }
        }
      }
    }
  }
}

::v-deep .el-radio__label {
  color: #333 !important;
  font-size: 24px !important;
}

::v-deep.el-button {
  width: 314px;
  height: 65px;
  border-radius: 33px;
  background: @blues;
  font-size: 38px;
  color: #fff;
}

::v-deep(.el-radio__inner) {
  border-radius: 2px;
}

::v-deep .el-radio__input.is-checked .el-radio__inner {
  background: @blues;
  border-color: @blues;
}

::v-deep(.el-radio__input.is-checked) .el-radio__inner::after {
  content: "";
  width: 10px;
  height: 5px;
  border: 1px solid white;
  border-top: transparent;
  border-right: transparent;
  text-align: center;
  display: block;
  position: absolute;
  top: 2px;
  left: 0px;
  vertical-align: middle;
  transform: rotate(-45deg);
  border-radius: 0px;
  background: none;
}

::v-deep .el-form-item__content {
  margin-left: 0 !important;
  width: 570px;
}

::v-deep .el-input__inner {
  font-size: 24px;
  color: @blues;
  width: 570px;
  height: 65px;
  border-radius: 10px;
}
</style>
